import React, { useState, useEffect, useRef } from 'react'; 
import Select, { createFilter } from "react-select";
import { useUpdateEffect } from '../../../../hooks/useUpdateEffect'; 

const DistatntionSelect = ({
  parentOptions,
  childOptions,
  parentId,
  childId,
  styles,
  onChange,
  join,
  label,
  placeholder,
  placeholderSub,
  validate,
  validateMsg,
  validateSub,
  validateSubMsg,
  parentIsPerson,
  childIsPerson,
  isDisabled
}) => {
  const hasDefaultParent = useRef(false);
  const [parents, setParents] = useState([]);
  const [childs, setChilds] = useState([]);  
  const [selectedParent, setSelectedParent] = useState(null);
  const [selectedChild, setSelectedChild] = useState(null);

  const filteredChilds = selectedParent && selectedParent.value
    ? childs.filter(child => child.parentId === selectedParent.value)
    : [];

  useEffect(() => {   
    const parentMap = parentOptions.map(parent => ({
      value: parent.id,
      label: parentIsPerson ? `${parent.firstname} ${parent.lastname}` : parent.code
    }));
    
    setParents(parentMap);

    const childMap = childOptions.map(child => ({
      value: child.id,  
      label: childIsPerson ? `${child.firstname} ${child.lastname}` : child.name, 
      parentId: child[join]
    }));

    setChilds(childMap);
 
    const foundParent = parentMap.find(parent => parent.value === parentId);
    const foundChild = childMap.find(child => child.value === childId);
    setSelectedParent(foundParent);
    setSelectedChild(foundChild);

    hasDefaultParent.current = true;
  }, [parentOptions, childOptions, parentId, childId, join, parentIsPerson, childIsPerson]);

  useUpdateEffect(() => {
    if (!hasDefaultParent.current) {
      setSelectedChild(null);
    } else {
      hasDefaultParent.current = false;
    }
  }, [selectedParent]);

  const customFilter = (option, searchText) => {
    return option.data.label.toLowerCase().startsWith(searchText.toLowerCase());
  };

  const handleChildChange = selectedOption => {
    if (selectedOption) {
      onChange(selectedOption.parentId, selectedOption.value);
      setSelectedChild(selectedOption);
    } else {
      onChange(null, null);
      setSelectedChild(null);
    }
  };

  const handleParentChange = selectedOption => {
    if (selectedOption) {
      onChange(selectedOption.value, 0);
      setSelectedParent(selectedOption);
    } else {
      onChange(null, 0);
      setSelectedParent(null);
    }
  };

  const stylesError = {
    placeholder: (provided) => ({
      ...provided,
      color: "rgb(225 29 72)",
      fontSize: "13px",
      fontWeight: '600',
      textAlign: 'left',
    })
  };

  const containerStyle = validateSub ? {
    border: '1px solid rgb(225, 29, 72)',
    display: 'flex',
    gap: '0px',
    borderRadius: '5px',
    padding: '0 4px'
  } : {
    border: '1px solid var(--border-color)',
    display: 'flex',
    gap: '0px',
    borderRadius: '5px',
    padding: '0 4px'
  };

  return (
    <div style={containerStyle}>
      <div style={{ minWidth: "35%", maxWidth: "35%" }}>
        <Select
          styles={validate ? { ...styles, ...stylesError } : styles}
          options={parents}
          value={selectedParent}
          onChange={handleParentChange}
          placeholder={placeholder}
          isClearable
          filterOption={createFilter({ ignoreAccents: false })}
          isDisabled={isDisabled}
        />
        {validate && validateMsg && (
          <div style={{ color: 'rgb(225, 29, 72)', fontSize: '12px' }}>{validateMsg}</div>
        )}
      </div>
      <div style={{ minWidth: "65%", maxWidth: "65%" }}>
        <Select
          styles={validateSub ? { ...styles, ...stylesError } : styles}
          options={filteredChilds}
          value={selectedChild}
          onChange={handleChildChange}
          placeholder={placeholderSub}
          isClearable
          isDisabled={isDisabled}
        />
        {validateSub && validateSubMsg && (
          <div style={{ color: 'rgb(225, 29, 72)', fontSize: '12px' }}>{validateSubMsg}</div>
        )}
        <label style={validateSub ? { color: 'rgb(225, 29, 72)' } : { color: 'var(--muted-text-color)' }}>
          {label}
        </label>
      </div>
    </div>
  );
};

export default DistatntionSelect;
